"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signAndSendAllTransactions = void 0;
const signAndSendAllTransactions = ({ transactionsAndSigners, connection, wallet, commitment = 'confirmed', onBeforeApprove, onAfterSend, onSuccess, onError, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        onBeforeApprove === null || onBeforeApprove === void 0 ? void 0 : onBeforeApprove();
        const { blockhash, lastValidBlockHeight } = yield connection.getLatestBlockhash(commitment);
        const transactions = transactionsAndSigners.map(({ transaction, signers }) => {
            transaction.recentBlockhash = blockhash;
            transaction.feePayer = wallet === null || wallet === void 0 ? void 0 : wallet.publicKey;
            if (signers === null || signers === void 0 ? void 0 : signers.length) {
                transaction.sign(...signers);
            }
            return transaction;
        });
        const signedTransactions = yield (wallet === null || wallet === void 0 ? void 0 : wallet.signAllTransactions(transactions));
        const txids = yield Promise.all(signedTransactions.map((signedTransaction) => connection.sendRawTransaction(signedTransaction.serialize())));
        onAfterSend === null || onAfterSend === void 0 ? void 0 : onAfterSend();
        // await Promise.all(
        //   txids.map((txid) =>
        //     connection.confirmTransaction({
        //       signature: txid,
        //       blockhash,
        //       lastValidBlockHeight,
        //     }),
        //   ),
        // );
        yield new Promise((r) => setTimeout(r, 7000));
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        return true;
    }
    catch (error) {
        onError === null || onError === void 0 ? void 0 : onError(error);
        return false;
    }
});
exports.signAndSendAllTransactions = signAndSendAllTransactions;
